import(/* webpackMode: "eager" */ "/app/app/(protected)/parcels/get-parcel/expected-parcels/page.tsx");
